<template>
    <BaseSection>
        <template
            v-if="headerText"
            #title
        >
            <component
                :is="headerTextSize"
                :id="slugify(headerText).toLowerCase()"
            >
                {{ headerText }}
            </component>
        </template>

        <template #default>
            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="richText"
                data-allow-anchor
                v-html="richText"
            />
            <!-- eslint-enable vue/no-v-html -->
        </template>
    </BaseSection>
</template>
<script setup lang="ts">
import slugify from 'slugify';

type Props = {
    headerText?: string | null,
    headerTextSize?: string | null,
    richText?: string | null,
};

defineProps<Props>();
</script>
